"use strict";

define('rs/model.mapper',['vertebrae'], function (Vertebrae) {
  var ExtendedClass = Vertebrae.Object.extend({
    DEBOUNCE_TIME: 100,
    initialize: function initialize(options) {
      options = _.extend({}, options);
      this.src = options.src;
      this.dest = options.dest || new Backbone.Model();
      this.mappings = [];
      this._duplex = false;
      this._copy = _.debounce(_.bind(this.copy, this), this.DEBOUNCE_TIME);
    },
    duplex: function duplex(val) {
      this._duplex = !!val;
      return this;
    },
    attr: function attr(src, dest, duplex) {
      if (!dest) {
        dest = src;
      }
      this.mappings.push({
        src: src,
        dest: dest
      });
      this.listenTo(this.src, 'change:' + src, this._copy);
      if (this._duplex || duplex) {
        this.listenTo(this.dest, 'change:' + dest, function () {
          this.src.set(src, this.dest.get(dest));
        });
      }
      this.copy();
      return this;
    },
    attrs: function attrs(mappings) {
      _.each(mappings, function (mapping) {
        this.attr(mapping.src, mapping.dest);
      }, this);
      return this;
    },
    copy: function copy() {
      var mappings = this.mappings;
      for (var i = 0, len = mappings.length, mapping; i < len; i++) {
        mapping = mappings[i];
        this.dest.set(mapping.dest, this.src.get(mapping.src));
      }
      return this;
    },
    model: function model() {
      return this.dest;
    }
  }, {
    map: function map(model) {
      return new this({
        src: model
      });
    }
  });
  return ExtendedClass;
});

